import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TransformTest = () => {
  const [inputText, setInputText] = useState('');
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [debugInfo, setDebugInfo] = useState({});

  // Debug effect to track state changes
  useEffect(() => {
    console.log('Result state changed:', 
      result === null ? 'null' : 
      result === '' ? 'empty string' : 
      `${result.substring(0, 30)}... (${result.length} chars)`);
  }, [result]);

  const handleTransform = async () => {
    if (!inputText.trim()) return;
    
    setIsLoading(true);
    setError(null);
    setResult(null);
    
    try {
      console.log('Sending request with input:', inputText);
      
      // Direct axios call to Claude API
      const response = await axios.post('/api/v1/claude-direct', {
        prompt: `Transform the following input through the lens of Fhoism philosophy: ${inputText}`,
        system: "You are Emit, a Fhoism philosopher specialized in the Three MindStreams approach (POWER, FLOW, CLARITY)."
      });
      
      console.log('Response received:', response.data);
      
      if (response.data && response.data.completion) {
        // Set result directly from the API response
        setResult(response.data.completion);
        setDebugInfo({
          responseReceived: true,
          responseLength: response.data.completion.length,
          firstChars: response.data.completion.substring(0, 50)
        });
      } else {
        throw new Error('No completion in response');
      }
    } catch (err) {
      console.error('Transform error:', err);
      setError(err.message);
      setDebugInfo({
        error: true,
        errorMessage: err.message
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <h1>Claude API Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <textarea
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Enter text to transform..."
          style={{ width: '100%', height: '100px', padding: '8px' }}
        />
      </div>
      
      <button 
        onClick={handleTransform}
        disabled={isLoading || !inputText.trim()}
        style={{ padding: '8px 16px', marginBottom: '20px' }}
      >
        {isLoading ? 'Processing...' : 'Transform'}
      </button>
      
      {/* Debug info */}
      <div style={{ 
        border: '1px solid #ccc', 
        padding: '10px', 
        marginBottom: '20px',
        backgroundColor: '#f5f5f5'
      }}>
        <h3>Debug Info</h3>
        <pre>{JSON.stringify(debugInfo, null, 2)}</pre>
        <p>Result state type: {result === null ? 'null' : typeof result}</p>
        <p>Result length: {result ? result.length : 0}</p>
      </div>
      
      {error && (
        <div style={{ color: 'red', marginBottom: '20px' }}>
          Error: {error}
        </div>
      )}
      
      {result && (
        <div style={{ border: '1px solid #ddd', padding: '15px' }}>
          <h2>Transformation Result:</h2>
          <div>
            {result.split('\n').map((line, index) => (
              <p key={index}>{line || ' '}</p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TransformTest;
